import { api } from "./api";

export const getSituacoesInscricao = () => api.get("/lookup/situacoes-inscricao");
export const getSituacoesEntrega = () => api.get("/lookup/situacoes-entrega");
export const getTiposLancamento = (natureza) =>
  api.get(`/lookup/tipos-lancamento${natureza ? `?natureza=${natureza}` : ""}`);
export const getEdicoes = () => api.get("/lookup/edicoes");
export const getFormularioPorEdicao = (idEdicao) =>
  api.get(`/lookup/formulario?idEdicao=${idEdicao}`);
export const getTiposDocumento = () => api.get("/lookup/tipos-documento");
